import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const behavior_types:SchemaTableOptions = {
    name:<string> 'behavior_types',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'type', value: 'VARCHAR(255) NOT NULL'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
    ]
}